// SMOOTH SCROLL TO NEXT ELEMENTOR WIDGET FOR ANCHOR LINKS
document.addEventListener('DOMContentLoaded', function() {
    var link = document.querySelector('a[href="#next-content"]');
    if (!link) return;

    link.addEventListener('click', function(e) {
        e.preventDefault();

        // Zoek het eerstvolgende element met class .elementor-widget-container na de link
        var nextWidget = null;
        var current = link.parentElement;

        while (current) {
            // Zoek volgende siblings
            var sibling = current.nextElementSibling;
            while (sibling) {
                if (sibling.classList.contains('elementor-element')) {
                    nextWidget = sibling;
                    break;
                }
                sibling = sibling.nextElementSibling;
            }
            if (nextWidget) break;
            current = current.parentElement;
        }

        if (nextWidget) {
            nextWidget.scrollIntoView({ behavior: 'smooth' });
        }
    });

});